/** @format */

import React, { useState } from "react";

function GenerateCollapsibleInteractions({ obj, i }) {
  const [innerText, setInnerText] = useState(false);
  return (
    <div className="position-relative t-1">
      <ul className="p-0 my-0">
        <li style={{ listStyle: "none" }}>{obj.interaction[0]}</li>
        <span className="collapse" id={`td-interaction-${i}`}>
          {obj.interaction.slice(1).map((interaction) => {
            return <li>{interaction}</li>;
          })}
        </span>
      </ul>
      <p>
        <a
          href={() => false}
          data-toggle="collapse"
          data-target={`#td-interaction-${i}`}
          className="collapsed"
          aria-expanded="false"
          onClick={() => setInnerText(!innerText)}
        >
          {innerText ? "Show Less" : "Show More"}
        </a>
      </p>
    </div>
  );
}

export default GenerateCollapsibleInteractions;
